<template>
  	<div>
		<div class="topbar">
				<div class="w1200 bc">
					<ul class="topbar-right fr">
						<li v-if="isLogin==false">
							<a class="co2" :href="loginUrl">[登录]</a>
						</li>
						<li v-if="isLogin==false">
							<a class="co2" :href="registerUrl">[注册]</a>
						</li>
						<li v-if="isLogin==true">
						<span>您好</span>
						</li>
						<li v-if="isLogin==true">
							<a class="co2" :href="userCenterUrl">{{account}}</a>
						</li>
						<li v-if="isLogin==true">
							<a class="co2" @click="logout()">[退出]</a>
						</li>

						<li>
							<a :href="aboutUsUrl">关于我们</a>
						</li>
						<!--li v-if="isLogin==true">
							<a @click="jumpTo('address_list')">收货地址</a>
						</li-->
						<li>
							<a v-bind:href="contactUrl" target="_blank">联系客服</a>
						</li>
						<!--<li>
							<a v-on:mouseenter="mobileAppShow()" v-on:mouseleave="mobileAppHidden()">手机商城</a>
							<div class="demensional_code" v-if="isShow">
								<img width="100px" src="../../../static/images/dimensional_code.png" />
							</div>
						</li>-->
					</ul>
					<ul class="topbar-left fl">
						<li>
							您好！欢迎来到相伴宝！
						</li>
						<li>
							<a class="co1" :href="indexUrl">返回相伴宝</a>
						</li>
					</ul>
				</div>
		</div>
		<div class="clear"></div>
		<sortHeader></sortHeader>
		<!--顶部：导航 开始-->
		<heardernav ref="navComp"></heardernav>
		<!--顶部：导航 结束-->
		
		<div class="clear mt15"></div>
	
		<!--container 开始-->
		<div class="container">
		    <div class="clear mt15"></div>
			<div class="top">
			    <ul>
			    <p class="n1">1.积分获取方式：<br/>
			        ▲在云商城消费奖励积分商品<br/>
			        ▲在商城积分活动中获得积分</p>
			    <p class="n2">2.积分使用方法：<br/>
			        ▲积分可以代替现金购买商城内的积分商品<br/>
			        ▲积分可以换取云商城专属的礼品</p>
			    <p class="n3">云商城 秋冬货品持续更新中...</p>
			    </ul>
			</div>
		    <div class="shopWarp">
		        <div class="shopBox">
		            <ul>
		                <li  v-for="goodsBo in goodsList"  @click="toGoodsDetail(goodsBo.goodsCode)">
		                    <img v-bind:src="goodsBo.imgMiddle" alt="暂无图片" >
		                    <div class="shopBox-right">
		                        <p class="rightTitle">{{goodsBo.goodsName}}</p>
		                        <p class="rightdetail"></p>
		                        <div class="priceleft ov_hid">
		                            <a href="#" class="priceright right">
		                                	马上兑
		                            </a>
		                            <!--
                                    	<span class="originalPrice">￥{{(goodsBo.unitPrice/100).toFixed(2)}}</span><br>
                                    -->
		                            <span v-if="goodsBo.unitPrice>0" class="currentPrice">￥{{(goodsBo.unitPrice/100).toFixed(2)}}</span>
		                        </div>
		                        <div class="duihuan" v-if="goodsBo.goodsPrice>0">兑换积分：<span>{{(goodsBo.goodsPrice)}}</span></div>
		                        <div class="duihuan" v-if="goodsBo.discountMoney>0">可抵扣：<span>￥{{(goodsBo.discountMoney/100).toFixed(2)}}</span></div>
		                    </div>
		                </li>
<!--		                <li>
		                    <img src="../../../static/images/shop1.png" alt="" >
		                    <div class="shopBox-right">
		                        <p class="rightTitle">电子狗双镜头行车记录仪一体机</p>
		                        <p class="rightdetail">标配也带电子狗</p>
		                        <div class="priceleft">
		                            <a href="#" class="priceright right">
		                                马上抢
		                            </a>
		                            <span class="originalPrice">￥1280</span><br>
		                            <span class="currentPrice">￥238</span>
		                        </div>
		                        <div class="duihuan">兑换积分：<span>2380</span></div>
		                    </div>
		                </li>-->
		
		            </ul>
		        </div>
		    </div>		
		<div class="dp-pages tc">
            <a @click="prePage()"> < </a>
            <a v-bind:class='{"current_page":currentPage === page}' v-for="page in pageList" @click="queryByPage(page)">{{page}}</a>
            <a @click="nextPage()"> > </a>
        </div>
        </div>
		<!--container 结束-->
	
		<footermenu></footermenu>
		<footercopyright></footercopyright>
	</div>
</template>
<script>
/*引入Vue框架*/
import Vue from 'vue'
/*引入资源请求插件*/
import VueResource from 'vue-resource'
/*使用VueResource插件*/
Vue.use(VueResource)
import jQuery from 'jquery';
import TopBar from '@/components/TopBar'
import Header from '@/components/Header'
import FooterMenu from '@/components/FooterMenu'
import FooterCopyright from '@/components/FooterCopyright'
import HearderNav from '@/components/HearderNav'
import API from "../../../static/api/api.js"
import flipClock from "../../../static/js/flipclock.min.js"
import {getImgUrl,dateFormat,getValueFromMap,showMoney,parseResult,getIndexUrl,getAboutUsUrl,getEmallUrl,getUcUrl,sysContactUrl} from "../../../static/js/emallUtils.js"
import { Swipe, SwipeItem } from 'mint-ui';
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);

export default {
  name: 'index',
  data () {
    return {
		goodsList:[],
     	catCode:'categoryAll',
     	interval:'intervalAll',
     	sortTime:'timeAll',
     	currentPage:1,
     	totalPage:1,
     	orderBy:'',
     	orderAsc:'',
     	shopCode:'',
     	pageList:[1],
     	totalItem:0,
     	sortParam:'',
     	isInit:false,
     	isLogin:false,
     	isShow:false,
     	account:'',
     	contactUrl:'',
		loginUrl:'',
		registerUrl:'',
		logoutUrl:'',
		aboutUsUrl:'',  
		indexUrl:'',
		showItem:7,
    }
  },
  components:{
       'topbar':TopBar,
       'sortHeader':Header,
       'footermenu':FooterMenu,
	   'footercopyright':FooterCopyright,
	   'heardernav':HearderNav
  },
  methods:{
  	        jumpTo:function(name){
		  		this.$router.push({ name:name});
		  	},
        	toGoodsDetail:function(goodsCode){
				//this.$router.push({ name: 'goodsdetail', query:{goodsCode:goodsCode}});
				let routeData = this.$router.resolve({ path: '/goodsDetails', query: {goodsCode: goodsCode } });
				window.open(routeData.href, '_blank');
		  	},
		  	prePage:function(){
		  		if(this.currentPage > 1){
		  			 this.currentPage = this.currentPage -1;
		  			 this.adjustPageArray(this.currentPage);
		  			 this.getGoods();
		  		}
		  	},
		  	nextPage:function(){
		  		if(this.currentPage < this.totalPage){
		  			this.currentPage = this.currentPage +1;
		  			this.adjustPageArray(this.currentPage);
		  			this.getGoods();
		  		}
		  	},
		  	queryByPage:function(page){
	  			this.currentPage = page;
	  			this.adjustPageArray(this.currentPage);
	  			this.getGoods();
		  	},
		  	adjustPageArray:function(page){
		  		if(page == this.pageList[6] && (page+2) <= this.totalPage){
		  			this.pageList.push(page+1);
		  			this.pageList.push(page+2);
		  			this.pageList.shift();
		  			this.pageList.shift();
		  		}else if(page == this.pageList[6] && (page+1) == this.totalPage){
		  			this.pageList.push(page+1);
		  			this.pageList.shift();
		  		}else if(page == this.pageList[0] && page >= 3){
		  			this.pageList.unshift(page-1);
		  			this.pageList.unshift(page-2);
		  			this.pageList.pop();
		  			this.pageList.pop();
		  		}else if(page == this.pageList[0] && page == 2){
		  			this.pageList.unshift(page-1);
		  			this.pageList.pop();
		  		}
		  	},
		  	initPageArray:function(){
			 	var pageList = new Array();
			 	var totalPage = this.totalPage;
	         	for(var i=1;i<=totalPage;i++){
	     	 		if(i <= this.showItem){
	     	 			pageList.push(i);
	     	 		}
	         	}
				this.pageList = pageList;
			},
		  	getGoods:function(){
				var that = this;
				var interval = that.interval;
				var catCode = that.catCode;
				var isQueryAll = "n";
			    var shopCode = that.shopCode;
				var cabinetId = "";
				var pageSize = 9;
				var currentPage = that.currentPage;
				var orderBy = that.orderBy;
				var orderAsc = that.orderAsc;
		   		var sortTime = that.sortTime;
		   		var goodsName = encodeURI(that.sortParam);
		   		var firstCatCode = "point_use_area";
		   		var brandId = that.brandId;
		   		var product_type="";
		   		var order_type="";
				API.getGoodsList(cabinetId,catCode,interval,currentPage,orderBy,orderAsc,shopCode,sortTime,pageSize,isQueryAll,goodsName,firstCatCode,brandId,product_type,order_type,function(ret){
					if(ret.code == "success"){
						var goods = ret.data.goods;
						that.totalItem = ret.data.totalItem;
						var totalPage = ret.data.totalPage;
						if(totalPage != undefined && totalPage != 0 && totalPage != that.totalPage ){
							that.totalPage = ret.data.totalPage;
							that.initPageArray();
						}else if(totalPage != undefined){
							that.totalPage = 1;
							that.initPageArray();
						}
						if(goods != undefined){
							for(var i=0;i<goods.length;i++){
								//商品图片
								var imgMiddle = goods[i].imgMiddle;
			                    if(imgMiddle.indexOf(";")!=-1){
			                    	imgMiddle=imgMiddle.split(";")[0];
			                    }
			                    imgMiddle = getImgUrl()+"/upload/show.htm?filePath="+imgMiddle;
			                    goods[i].imgMiddle = imgMiddle;
			                    goods[i].discountMoney = JSON.parse(goods[i].attrValue).discountMoney;
			                    
			                    if(firstCatCode=='spike'){
			                    	
	 						var marketPrice=JSON.parse(goods[i].attrValue).marketPrice;
	 						var saleTimeStr=JSON.parse(goods[i].attrValue).saleTimeShow;
	 						var saleEndTimeStr=JSON.parse(goods[i].attrValue).saleEndTimeShow;
	 						
	 						if(marketPrice!=undefined && marketPrice!=""){
	                    		goods[i].marketPrice=marketPrice;
			 				}else{
			 					goods[i].marketPrice=goods[i].unitPrice;
			 				}
			 				if(saleEndTimeStr!=undefined&&saleEndTimeStr!=''){
			 					saleEndTimeStr=saleEndTimeStr.replace(/-/g,"/");
								var saleEndDate = new Date(saleEndTimeStr);
								
								saleTimeStr=saleTimeStr.replace(/-/g,"/");
								var saleDate = new Date(saleTimeStr);
								
								//如果当期日期大于销售结束日期 xxx
								if(new Date() > saleEndDate){
									goods[i].saleStatus="end";
								}else if(new Date() < saleDate){//如果当期时间小于上架时间，展示距离开始 时间
									goods[i].saleStatus="wait_start";
									var begSeconds = saleDate.getTime() - new Date().getTime();   //时间差的毫秒数        
    								//计算出相差天数  
//  								var days=Math.floor(begSeconds/(24*3600*1000));  
    								//计算出小时数  
    								var leave1=begSeconds%(24*3600*1000);    //计算天数后剩余的毫秒数  
    								var hours=Math.floor(begSeconds/(3600*1000));  
    								//计算相差分钟数  
    								var leave2=leave1%(3600*1000);        //计算小时数后剩余的毫秒数  
    								var minutes=Math.floor(leave2/(60*1000));  
    								//计算相差秒数  
    								var leave3=leave2%(60*1000);      //计算分钟数后剩余的毫秒数  
   									var seconds=Math.round(leave3/1000); 
// 									goods[i].day=days;
   									goods[i].hour=hours;
   									goods[i].minute=minutes;
   									goods[i].second=seconds;
								}else{
									goods[i].saleStatus="on_sale";
									
									var begSeconds = saleEndDate.getTime() - new Date().getTime();   //时间差的毫秒数        
    								//计算出相差天数  
//  								var days=Math.floor(begSeconds/(24*3600*1000));  
    								//计算出小时数  
    								var leave1=begSeconds%(24*3600*1000);    //计算天数后剩余的毫秒数  
    								var hours=Math.floor(begSeconds/(3600*1000));  
    								//计算相差分钟数  
    								var leave2=leave1%(3600*1000);        //计算小时数后剩余的毫秒数  
    								var minutes=Math.floor(leave2/(60*1000));  
    								//计算相差秒数  
    								var leave3=leave2%(60*1000);      //计算分钟数后剩余的毫秒数  
   									var seconds=Math.round(leave3/1000);  
// 									goods[i].day=days;
   									goods[i].hour=hours;
   									goods[i].minute=minutes;
   									goods[i].second=seconds;
								}
			 				}

			                    }
							}
						}
						that.goodsList = goods;
						if(!that.isInit){
							that.isInit = true;
							that.initPageArray();
						}
					}
				});
			 },
			shopCartShow:function(){
				this.isShow = true;
			},
			shopCartHide:function(){
				this.isShow = false;
			},
  },
  beforeDestroy () {
  },
  mounted(){
	window.scrollTo(0, 0);
	var account = localStorage.getItem("account");
	if(account != undefined && account != ""){
		this.isLogin = true;
		this.account = account;
	}  	
	this.userCenterUrl = getUcUrl() + '/index/default.htm';
	this.loginUrl = getUcUrl() + '/login.htm';
	this.registerUrl = getUcUrl() + '/custm/user/user_reg_add.htm?formCode=MCHT_USER_FORM';
	this.logoutUrl = getUcUrl() + '/logout.htm';
	this.aboutUsUrl = getAboutUsUrl();
	this.indexUrl = getIndexUrl();
	this.orderUrl = getEmallUrl() + '/orderManage/myOrderList.htm';
	this.getGoods();
  }
}
</script>

<style scoped>
       *{margin: 0px;padding: 0px;}
        .left{float: left}
        .right{ float: right;}
        .clear{clear: both;}
        li{
            display: inline-block;
            list-style: none;
        }
        .top{
            background: url(../../../static/images/jifen-top.jpg) center center no-repeat;
            height: 449px;
        }
        .top ul{
            width: 1200px;
            margin: 0 auto;
            position: relative;
            height: 449px;
        }
        .top ul .n1{
            position: absolute;
            left:0;
            top:60px;
            font-size: 17px;
            text-align: left;
            color: #fff;
            line-height: 1.8;
        }
        .top ul .n2{
            position: absolute;
            right:0;
            top:60px;
            font-size: 17px;
            text-align: right;
            color: #fff;
            line-height: 1.8;
        }
        .top ul .n3{
            position: absolute;
            left:0;
            bottom:20px;
            font-size: 24px;
            text-align: right;
            color: #db254d;
        }
        .shopWarp{
            width: 100%;
            background: #f9f9f9;
        }
        .shopWarp li{
            width: 368px;
            height: 170px;
            padding: 10px;
            background: #ffffff;
            border-radius: 5px;
            margin: 5px;
            border: 1px solid #ffffff;
        }
        .shopWarp li> img{
            display: block;
            width: 170px;
            height: 170px;
            float: left;
            margin:  auto 0px;
        }
        .shopWarp li:hover{
            border: 1px solid #E12816;
        }
        .nowImg{
            width: 50px;
        }
        .shopBox-right{margin-left: 190px}
        .rightTitle{color: gray;height: 40px; line-height: 20px;}
        .rightdetail{
            color: #EF807C;
            font-size: 12px;
        }
        .shopBox-right .currentPrice{
            color: #fd6862;
            font-weight: bolder;
            font-size: 18px;

        }
        .shopBox-right .originalPrice{
            font-size: 12px;
            color: gainsboro;
            text-decoration: line-through;

        }
        .priceright{background-color: #fcdcdd; border-radius: 5px; font-size: 14px; color: #fc4247; padding: 8px 15px; text-align: center; margin-top: 10px;}
        .priceleft{ margin-top: 20px;}
        .num{ margin-top: 20px; overflow: hidden; margin-bottom: 5px;}
        .num span{
            color: #c9c9c9;
            font-size: 13px;
        }
        .shopWarp .down{
            width: 208px;
            height: 11px;
            border: 1px solid #EF807C ;
            border-radius: 10px;
        }
        .shopWarp .down div{
            width: 100px;
            height: 11px;
            background: #f99693;
            border-radius: 10px 0px 0px 10px;
        }
        .shopBox {width: 1210px; margin: 0px auto;}
        .duihuan{
            color: #fd2a91;
            font-size: 15px;
            margin-top: 20px;
        }
        .duihuan span{
            color: #fc232c;
        }
</style>
<style>
.top_shopcart{
	/*position: absolute;*/
    /*left: auto;*/
    /*right: 20rem;*/
    /*top: 30px;*/
    z-index:777;
    width: 310px;
    border: 1px solid #cfcfcf;
    background-color: #fff;
    border-bottom: 3px solid #60575a;
    position: relative;
    top: 0px;
    left: -112px;
	}
.mylist h4,.head-nav .mycart .goods-list .mylist h4{ text-align:left; padding-left:10px; font-size:14px;}
.mylist ul li,.head-nav .mycart .goods-list .mylist ul li{ padding:0 10px; text-align:left;font-size:12px;}
.mylist ul li.li-1,.head-nav .mycart .goods-list .mylist ul li.li-1{ height:30px; line-height:30px; background:#f9f9f9;}
.mylist ul li.li-2,.head-nav .mycart .goods-list .mylist ul li.li-2{ padding:10px;line-height:20px; overflow:hidden;}
.mylist ul li.li-2 .name,.head-nav .mycart .goods-list .mylist ul li.li-2 .name{ width:140px; float:left; margin-left:10px; }
.mylist ul li.li-2 .del,.head-nav .mycart .goods-list .mylist ul li.li-2 .del{ float:right;}
.mylist .spic,.head-nav .mycart .goods-list .mylist .spic{ border:solid 1px #ddd; padding:3px;}
.mylist .fbar,.head-nav .mycart .goods-list .mylist .fbar{ height:40px; line-height:40px; background:#f9f9f9;overflow:hidden;}
.mylist .fbar .gobuy,.head-nav .mycart .goods-list .mylist .fbar .gobuy { display:inline-block; margin-right:10px; margin-top:5px;padding:5px 10px; height:20px; line-height:20px; border-radius:3px; color:#fff; background:#FF6600; }
</style>


// WEBPACK FOOTER //
// src/page/points/points_area.vue?4d43abb6